import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  List, 
  X, 
  FirstAidKit, 
  Users, 
  UserPlus, 
  Briefcase, 
  ChatCircle, 
  FileArrowDown, 
  ChartBar,
  Calendar,
  Gear
} from '@phosphor-icons/react';

const Sidebar = ({ isOpen, onClose, fleetId }) => {
  const navigate = useNavigate();

  const menuItems = [
    {
      id: 'schedule',
      label: 'Monthly Schedule',
      icon: Calendar,
      color: '#002FA7',
      path: `/fleet/${fleetId}/schedule`
    },
    {
      id: 'sick-leave',
      label: 'Sick Leave',
      icon: FirstAidKit,
      color: '#FF2A2A',
      path: `/fleet/${fleetId}/sick-leave`
    },
    {
      id: 'management',
      label: 'Management',
      icon: Briefcase,
      color: '#002FA7',
      path: `/fleet/${fleetId}/management`
    },
    {
      id: 'add-member',
      label: 'Add Member',
      icon: UserPlus,
      color: '#10B981',
      path: `/fleet/${fleetId}/crew?action=add`
    },
    {
      id: 'crew',
      label: 'Team / Crew',
      icon: Users,
      color: '#6366F1',
      path: `/fleet/${fleetId}/crew`
    },
    {
      id: 'messages',
      label: 'Messages',
      icon: ChatCircle,
      color: '#F59E0B',
      path: `/fleet/${fleetId}/messages`
    },
    {
      id: 'export',
      label: 'Export & Summary',
      icon: FileArrowDown,
      color: '#8B5CF6',
      path: `/fleet/${fleetId}/export`
    },
    {
      id: 'rules',
      label: 'Settings',
      icon: Gear,
      color: '#6B7280',
      path: `/fleet/${fleetId}/rules`
    }
  ];

  const handleNavigation = (path) => {
    navigate(path);
    onClose();
  };

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <div 
        className={`fixed top-0 left-0 h-full w-80 bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <List size={28} weight="bold" className="text-[#002FA7]" />
            <h2 className="text-xl font-bold text-gray-900">Menu</h2>
          </div>
          <button 
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X size={24} className="text-gray-600" />
          </button>
        </div>

        {/* Menu Items */}
        <nav className="py-4">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.id}
                onClick={() => handleNavigation(item.path)}
                className="w-full flex items-center gap-4 px-6 py-4 hover:bg-gray-50 transition-colors group"
              >
                <Icon 
                  size={24} 
                  weight="duotone" 
                  style={{ color: item.color }}
                  className="transition-transform group-hover:scale-110"
                />
                <span 
                  className="text-base font-medium"
                  style={{ color: item.color }}
                >
                  {item.label}
                </span>
              </button>
            );
          })}
        </nav>

        {/* Footer */}
        <div className="absolute bottom-0 left-0 right-0 p-6 border-t border-gray-200">
          <div className="text-xs text-gray-500 text-center">
            <p className="font-semibold">OmniLink Crew Schedule Pro</p>
            <p className="mt-1">Operations Dashboard</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
